<template>
  <section class="section-four">
    <div class="section-four--wrapper">
      <div class="section-title">
        <div class="section-top-title">
          <span class="title">Concorrenti</span>
        </div>
        <span class="text-two"> Distribuzione della {{ infocar.nome }} sul mercato </span>
      </div>
      <div class="dropdownSelect">
        <custom-select
          :options="selectOptions"
          v-model="currentSelection"
          placeholder="Seleziona un'opzione"
          :name="'typeSelection'"
          :isOpen="openDropdown === 0"
          @toggle="handleToggle(0)"
        ></custom-select>
      </div>
      <div id="kmChart" class="section-four--bottom">
        <div class="qrt-xy-chart">
          <div style="width: 100%; height: 100%; position: relative;">
            <bubble-chart
              :chart-data="bubbleChartDataKm"
              :chart-options="chartOptionsKm"
            ></bubble-chart>
          </div>
        </div>
      </div>
      <div id="yearChart" class="section-four--bottom" style="display:none;">
        <div class="qrt-xy-chart2">
          <div style="width: 100%; height: 100%; position: relative;"></div>
          <bubble-chart
            :chart-data="bubbleChartDataYears"
            :chart-options="chartOptionsYears"
          ></bubble-chart>
        </div>
      </div>
      <div class="section-four--footerText">
        Esplora i singoli punti del grafico per ulteriori informazioni
      </div>
    </div>
  </section>
</template>

<script>
import BubbleChart from './BubbleChart';
import CustomSelect from './CustomSelect';

export default {
  name: 'LivemarketDataCompetitors',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    competitors: {
      type: Object,
      required: true,
    },
  },
  components: {
    BubbleChart,
    CustomSelect,
  },
  computed: {
    bubbleChartDataKm() {
      const carData = {
        x: this.competitors.auto.chilometri,
        y: this.competitors.auto.prezzo,
        r: 13,
        isCarPoint: true,
        info: null,
      };

      const pointData = this.competitors.points.map(point => ({
        x: point.ascisse.chilometri,
        y: point.ordinate.prezzoMercato,
        r: 5,
        isCarPoint: false,
        info: point.info,
      }));
      const combinedData = [...pointData, carData];

      return {
        datasets: [
          {
            data: combinedData,
            backgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#efefef')),
          },
        ],
      };
    },
    bubbleChartDataYears() {
      const sortedPoints = [...this.competitors.points].sort((a, b) => {
        const dateA = new Date(a.ascisse.immatricolazione + '-01');
        const dateB = new Date(b.ascisse.immatricolazione + '-01');
        return dateA - dateB;
      });

      const carData = {
        x: this.formatDate(this.competitors.auto.anno_mese),
        y: this.competitors.auto.prezzo,
        r: 13,
        isCarPoint: true,
        info: null,
      };

      const pointData = sortedPoints.map(point => ({
        x: this.formatDate(point.ascisse.immatricolazione),
        y: point.ordinate.prezzoMercato,
        r: 5,
        isCarPoint: false,
        info: point.info,
      }));

      const combinedData = [...pointData, carData];

      return {
        datasets: [
          {
            data: combinedData,
            backgroundColor: combinedData.map(p => (p.isCarPoint ? '#d20a11' : '#efefef')),
          },
        ],
      };
    },
    chartOptionsKm() {
      return {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: context => this.customTooltipLabelKm(context),
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Chilometri',
              color: 'black',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
          y: {
            title: {
              display: true,
              text: 'Prezzo',
              color: 'black',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
        },
      };
    },

    chartOptionsYears() {
      return {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: context => this.customTooltipLabelYears(context),
            },
          },
        },
        scales: {
          x: {
            type: 'category',
            title: {
              display: true,
              text: 'Data',
              color: 'black',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
          y: {
            title: {
              display: true,
              text: 'Prezzo',
              color: 'black',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
        },
      };
    },
  },
  data() {
    return {
      selectOptions: [
        { value: 'pricePerKm', text: 'Mostra Prezzo / km' },
        { value: 'pricePerYear', text: 'Mostra Prezzo / anno' },
      ],
      currentSelection: 'pricePerKm',
      openDropdown: null,
    };
  },
  watch: {
    currentSelection(newValue) {
      if (newValue === 'pricePerKm') {
        document.getElementById('kmChart').style.display = 'block';
        document.getElementById('yearChart').style.display = 'none';
      } else if (newValue === 'pricePerYear') {
        document.getElementById('kmChart').style.display = 'none';
        document.getElementById('yearChart').style.display = 'block';
      }
    },
  },
  methods: {
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    formatDate(dateStr) {
      const months = [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ];
      const [year, month] = dateStr.split('-');
      return `${months[parseInt(month) - 1]} ${year}`;
    },
    customTooltipLabelKm(context) {
      const dataPoint = context.raw;
      if (dataPoint.isCarPoint) {
        return `La tua Auto: ${dataPoint.x.toLocaleString()} km - Prezzo: ${dataPoint.y.toLocaleString()}€`;
      } else if (dataPoint.info) {
        return [
          `Chilometri: ${dataPoint.x.toLocaleString()} km`,
          `Comparazione Prezzo: ${dataPoint.info.comparazionePrezzo.toLocaleString()}€`,
          `Prezzo Mercato: ${dataPoint.y.toLocaleString()}€`,
          `Differenza Km: ${dataPoint.info.differenzaKm.toLocaleString()} km`,
        ];
      } else {
        return [
          `Chilometri: ${dataPoint.x.toLocaleString()} km`,
          `Prezzo: ${dataPoint.y.toLocaleString()}€`,
        ];
      }
    },
    customTooltipLabelYears(context) {
      const dataPoint = context.raw;
      if (dataPoint.isCarPoint) {
        return `La tua Auto: ${dataPoint.x} - Prezzo: ${dataPoint.y.toLocaleString()}€`;
      } else if (dataPoint.info) {
        return [
          `Anno: ${dataPoint.x.toLocaleString()} `,
          `Comparazione Prezzo: ${dataPoint.info.comparazionePrezzo.toLocaleString()}€`,
          `Prezzo Mercato: ${dataPoint.y.toLocaleString()}€`,
          `Differenza Km: ${dataPoint.info.differenzaKm.toLocaleString()} km`,
        ];
      } else {
        return [
          `Anno: ${dataPoint.x.toLocaleString()} `,
          `Prezzo: ${dataPoint.y.toLocaleString()}€`,
        ];
      }
    },
  },
};
</script>

<style scoped>
.section-four {
  padding: 40px 0px 24px;
  border-bottom: 2px solid #e4e4e4;
  margin: 0px 100px;
}
.section-four--wrapper {
  max-width: 830px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.section-title {
  display: flex;
  flex-direction: column;
}
.section-top-title {
  display: flex;
  justify-content: space-between;
}
.section-top-title .title {
  color: #d20a11;
  font-size: 21px;
  line-height: 28px;
  font-weight: bold;
}
.text-two {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 5px;
}
.dropdownSelect {
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: center;
  margin: 28px 0px 10px;
}

.section-four--footerText {
  color: #aaaaaa;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  margin-top: 5px;
}

@media (max-width: 992px) {
  .section-four {
    padding: 44px 20px 42px;
    margin: 0px 40px;
  }
}

@media (max-width: 600px) {
  .section-four {
    padding: 32px 0px 15px;
    margin: 0px 17px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataCompetitors.vue